import { DesktopShell } from '@/components/dashboard/DashboardShell';
import { FeedbackForm } from '@/components/dashboard/FeedbackForm';

export default function FeedbackDesktop() {
  return (
    <DesktopShell title="Feedback" subtitle="Report issues or share suggestions">
      <FeedbackForm />
    </DesktopShell>
  );
}
